import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { passwordValidator } from '../../shared/validator/password.validator';

@Component({
  selector: 'login-component',
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
  styleUrls: ['./login.component.scss'],
  templateUrl: './login.component.html',
})
export class LoginComponent {
  loginForm: FormGroup = new FormGroup({
    oldPassword: new FormControl('', [Validators.required, passwordValidator()]),
    password: new FormControl('', [Validators.required, passwordValidator()]),
    username: new FormControl('', Validators.required),
  });
}
